import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { MoreVertical } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useState } from "react";

interface ChatActionsProps {
  isGroup: boolean;
  onMarkResolved: () => void;
  onMarkAllResolved?: () => void;
  onUngroup?: () => void;
}

export function ChatActions({
  isGroup,
  onMarkResolved,
  onMarkAllResolved,
  onUngroup,
}: Readonly<ChatActionsProps>) {
  const [isTooltipOpen, setTooltipOpen] = useState(false);

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip open={isTooltipOpen} onOpenChange={setTooltipOpen}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            className="h-8 w-8 relative"
            onMouseEnter={() => setTooltipOpen(true)}
            onMouseLeave={() => setTooltipOpen(false)}
          >
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <span>
                  <MoreVertical className="h-4 w-4 dark:text-gray-200" />
                </span>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" onMouseEnter={() => setTooltipOpen(false)}>
                <DropdownMenuItem onClick={onMarkResolved} className="cursor-pointer">
                  Mark Resolved
                </DropdownMenuItem>
                {isGroup && (
                  <>
                    <DropdownMenuItem onClick={onMarkAllResolved} className="cursor-pointer">
                      Mark All Resolved
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={onUngroup} className="cursor-pointer">
                      Ungroup
                    </DropdownMenuItem>
                  </>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
          </Button>
        </TooltipTrigger>
        {isTooltipOpen &&
          <TooltipContent side="left">
            <p className="text-xs">Actions</p>
          </TooltipContent>
        }
      </Tooltip>
    </TooltipProvider>
  );
}
